import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS, apiRequest } from '../utils/api';

export default function Home() {
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // 获取首页视频列表
  useEffect(() => {
    const fetchVideos = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await apiRequest(API_ENDPOINTS.VIDEOS);
        if (!response.ok) throw new Error('获取视频失败');
        const data = await response.json();
        
        // 检查返回的数据是否是数组
        if (Array.isArray(data)) {
          setVideos(data);
        } else {
          // 如果返回的是错误对象，则设置为空数组并设置错误信息
          setVideos([]);
          setError(data.message || '数据格式错误');
        }
      } catch (err) {
        setVideos([]);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-blue-500">热门视频</h1>
      
      {isLoading && (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      )}
      
      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4">
          <p>{error}</p>
        </div>
      )}
      
      {!isLoading && !error && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {videos.map((video) => (
            <div 
              key={video.id} 
              onClick={() => navigate(`/video/${video.id}`)}
              className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 cursor-pointer"
            >
              <div className="relative">
                <img src={video.thumbnail} alt={video.title} className="w-full h-48 object-cover" />
                <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-xs px-2 rounded">
                  {video.duration}
                </div>
              </div>
              <div className="p-4">
                <h2 className="text-lg font-semibold mb-2 line-clamp-2">{video.title}</h2>
                <div className="flex items-center text-gray-600 text-sm">
                  <img src={video.author_avatar} alt={video.author} className="w-6 h-6 rounded-full mr-2" />
                  <span>{video.author}</span>
                  <span className="mx-2">•</span>
                  <span>{video.views}次播放</span>
                  <span className="mx-2">•</span>
                  <span>{video.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}